export default {
    common: {
        title: 'AI Innhold ',
        socialPlanner: 'Medie Planlegger',
        blog: 'Blogg',
        funnel: 'Forløp',
        website: 'Nettside',
        email: 'E-post',
        words: 'Ord',
        variations: 'Varianter',
    },
};
